<template>
  <el-popover :disabled="popoverDisabled" placement="top-start" trigger="hover">
    <template #reference>
      <el-tooltip
        :disabled="!mainIconParams.tooltip"
        effect="dark"
        placement="top-start"
        :content="mainIconParams.tooltip"
      >
        <img :src="mainIconParams.icon" alt="Countries" width="20px;" />
      </el-tooltip>
    </template>
    <el-tooltip
      v-for="code in countryCodes"
      :key="code"
      class="ml-1"
      effect="dark"
      placement="top-start"
      :content="code.toUpperCase()"
    >
      <img :src="getFlagSrc(code)" :alt="code.toUpperCase()" width="20px;" />
    </el-tooltip>
  </el-popover>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import worldwide from '@/apps/traforama/assets/icons/worldwide.png'

export default defineComponent({
  name: 'CountriesIcon',
  props: {
    countryCodes: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  setup(props) {
    const getFlagSrc = (code: string) => {
      return code
        ? `https://flagsapi.com/${code.toUpperCase()}/flat/64.png`
        : worldwide
    }

    const popoverDisabled = computed(() => {
      return !props.countryCodes.length || props.countryCodes.length === 1
    })

    const mainIconParams = computed(() => {
      if (!props.countryCodes.length) {
        return { icon: worldwide, tooltip: 'Worldwide' }
      } else if (props.countryCodes.length === 1) {
        return {
          icon: getFlagSrc(props.countryCodes[0]),
          tooltip: props.countryCodes[0].toUpperCase()
        }
      } else {
        return { icon: worldwide }
      }
    })

    return { getFlagSrc, mainIconParams, popoverDisabled }
  }
})
</script>
